<div class="px-4 sm:px-6 lg:px-8">
    <div [hidden]="!loading">
        <app-loading></app-loading>
    </div>
    <div [hidden]="loading" class="w-full px-2 sm:px-5 py-3">
        <form [formGroup]="templateForm" (submit)="submitProvider()">
            <div *ngIf="!isEditPage" class="w-full flex flex-col sm:flex-row justify-between gap-4 mb-6 sm:mb-12">
                <div>
                    <div class="flex items-center mb-1">
                        <a class="text-sm text-black">Templates</a>
                        <fa-icon class="w-5 flex justify-center text-black mx-2" [icon]="faChevronRight" size="xs" />
                        <a class="text-sm text-black">Template</a>
                    </div>
                    <h1 class="font-bold text-xl sm:text-2xl">Criar Template</h1>
                </div>
                <div class="flex justify-center items-center gap-2">
  <span
    (click)="cancelButton()"
    class="text-westetics-purple-800 border border-westetics-purple-800
           hover:bg-westetics-purple-800 hover:text-white cursor-pointer
           font-medium rounded-md px-3 py-2 transition-colors
           text-sm sm:text-base">
    Cancelar
  </span>

  <button
    class="bg-westetics-purple-800 hover:bg-westetics-purple-600
           cursor-pointer text-white font-medium rounded-md
           px-3 py-2 transition-colors text-sm sm:text-base">
    Cadastrar
  </button>
</div>

            </div>
            <div *ngIf="isEditPage" class="w-full flex flex-col sm:flex-row justify-between gap-4 mb-6 sm:mb-12">
                <div>
                    <div class="flex items-center mb-1">
                        <a class="text-sm text-black">Templates</a>
                        <fa-icon class="w-5 flex justify-center text-black mx-2" [icon]="faChevronRight" size="xs" />
                        <a class="text-sm text-black">Template</a>
                    </div>
                    <h1 class="font-bold text-xl sm:text-2xl">Editar Template</h1>
                </div>
                <div class="flex gap-2">
                    <span (click)="cancelButton()"
                        class="text-westetics-purple-800 border border-westetics-purple-800 hover:bg-westetics-purple-800 hover:text-white cursor-pointer font-medium rounded-md px-3 py-2 transition-colors text-sm sm:text-base">Cancelar</span>
                    <button
                        class="bg-westetics-purple-800 hover:bg-westetics-purple-600 cursor-pointer text-white font-medium rounded-md px-3 py-2 transition-colors text-sm sm:text-base">Salvar</button>
                </div>
            </div>
            <div class="w-full mb-6">
                <div class="grid gap-4 sm:gap-6 mb-6 grid-cols-1 md:grid-cols-2 items-end">
                    <div>
                        <label for="name" class="block mb-2 text-sm font-medium text-neutral-500">Nome do
                            Template*</label>
                        <input type="text" id="name" formControlName="name"
                            class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5 "
                            placeholder="Insira o Nome do Template" />
                        <span class="text-red-600 text-sm mb-0 leading-4" *ngIf="
                            templateForm.controls['name']?.invalid &&
                            templateForm.controls['name']?.touched
                            ">
                            Insira um nome de template válido.
                        </span>
                    </div>
                    <div *ngIf="templateForm.controls['urlLink'].value !== ''" class="flex cursor-pointer">
                        <div class="flex items-center">
                            <fa-icon class="w-5 flex justify-center text-black mr-2" [icon]="faFileDownload"
                                size="xs" />
                            <span class="text-sm text-black cursor-pointer" (click)="downloadCurrentTemplate()">Download
                                da Versão Atual</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
                <div class="w-full mb-4 sm:mb-6">
                    <label for="templateType" class="block mb-2 text-sm font-medium text-neutral-500">Tipo do
                        template*</label>
                    <select id="templateType" formControlName="templateType"
                        class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5 ">
                        <option value="" selected disabled>Escolha uma opção</option>
                        <option value="TCLE">TCLE</option>
                        <option value="PRESTACAO_DE_SERVICO">Contrato de prestação de serviço</option>
                        <option value="PRESTACAO_DE_SERVICO_MODELO">Paciente modelo - Contrato de prestação de serviço</option>
                        <option value="DOCUMENTO_AVULSO">Documento Avulso</option>
                        <option value="ANAMNESE_PHYSICAL">Anamnese Física</option>
                        <option value="ANAMNESE_VIRTUAL">Anamnese Virtual</option>
                        <option value="OTHER">Outros</option>
                    </select>
                </div>
                <!-- modulos com multipla seleção -->
                <div class="w-full mb-4 sm:mb-6">
                    <label for="modules" class="block mb-2 text-sm font-medium text-neutral-500">Módulo*</label>
                    <select id="modules" formControlName="module"
                        class="bg-gray-50 border disabled:border-none border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5 ">
                        <option value="" selected disabled>Escolha uma opção</option>
                        <option *ngFor="let module of modules" [value]="module.id">{{module.description}}</option>
                    </select>
                </div>
            </div>
            <div class="w-full p-4 sm:p-6 mb-4 border rounded-2xl cursor-pointer, border-dashed, border-westetics-blue">
                <input id="uploadTemplate" type="file" class="hidden" (change)="changeTemplateFile($event)"
                    accept=".docx,.pptx" />
                <label *ngIf="!templateForm.controls['file'].value" for="uploadTemplate"
                    class="w-full cursor-pointer flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-0">
                    <svg width="55" height="40" viewBox="0 0 55 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="w-10 h-10 sm:w-14 sm:h-14 flex-shrink-0">
                        <path
                            d="M46.2 17.4734C46.5523 16.5539 46.75 15.5484 46.75 14.5C46.75 9.94531 43.0547 6.25 38.5 6.25C36.807 6.25 35.2258 6.76562 33.9195 7.64219C31.5391 3.51719 27.0961 0.75 22 0.75C14.4031 0.75 8.25 6.90312 8.25 14.5C8.25 14.732 8.25859 14.9641 8.26719 15.1961C3.45469 16.8891 0 21.4781 0 26.875C0 33.707 5.54297 39.25 12.375 39.25H44C50.0758 39.25 55 34.3258 55 28.25C55 22.9305 51.2187 18.4875 46.2 17.4734ZM33.8078 22.75H28.1875V32.375C28.1875 33.1312 27.5688 33.75 26.8125 33.75H22.6875C21.9312 33.75 21.3125 33.1312 21.3125 32.375V22.75H15.6922C14.4633 22.75 13.8531 21.2719 14.7211 20.4039L23.7789 11.3461C24.3117 10.8133 25.1883 10.8133 25.7211 11.3461L34.7789 20.4039C35.6469 21.2719 35.0281 22.75 33.8078 22.75Z"
                            fill="#E5E6ED" />
                    </svg>
                    <div class="sm:ml-4 flex-1">
                        <h5 class="mb-1 text-base sm:text-xl font-medium tracking-tight text-neutral-500">{{isEditPage ? 'Envie o
                            template atualizado' : 'Envie o arquivo do template'}}
                        </h5>
                        <div class="flex">
                            <p class="font-normal text-xs sm:text-sm text-neutral-500">Formatos aceitos: <span
                                    class="text-ergon-green">.DOCX, .PPTX</span></p>
                        </div>
                    </div>
                    <div
                        class="w-full sm:w-auto sm:ml-auto bg-westetics-purple-800 hover:bg-westetics-purple-600 cursor-pointer text-white font-medium rounded-md px-4 py-2 sm:py-3 transition-colors text-center text-sm sm:text-base">
                        <span>Upload</span>
                    </div>
                </label>
                <label *ngIf="templateForm.controls['file'].value" for="upload"
                    class="w-full cursor-pointer flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-0">
                    <svg width="55" height="40" viewBox="0 0 55 40" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="w-10 h-10 sm:w-14 sm:h-14 flex-shrink-0">
                        <path
                            d="M46.2 17.4734C46.5523 16.5539 46.75 15.5484 46.75 14.5C46.75 9.94531 43.0547 6.25 38.5 6.25C36.807 6.25 35.2258 6.76562 33.9195 7.64219C31.5391 3.51719 27.0961 0.75 22 0.75C14.4031 0.75 8.25 6.90312 8.25 14.5C8.25 14.732 8.25859 14.9641 8.26719 15.1961C3.45469 16.8891 0 21.4781 0 26.875C0 33.707 5.54297 39.25 12.375 39.25H44C50.0758 39.25 55 34.3258 55 28.25C55 22.9305 51.2187 18.4875 46.2 17.4734ZM33.8078 22.75H28.1875V32.375C28.1875 33.1312 27.5688 33.75 26.8125 33.75H22.6875C21.9312 33.75 21.3125 33.1312 21.3125 32.375V22.75H15.6922C14.4633 22.75 13.8531 21.2719 14.7211 20.4039L23.7789 11.3461C24.3117 10.8133 25.1883 10.8133 25.7211 11.3461L34.7789 20.4039C35.6469 21.2719 35.0281 22.75 33.8078 22.75Z"
                            fill="#E5E6ED" />
                        <path d="M20 24.25L23.5 27.75L34.5 16.75" stroke="#4CAF50" stroke-width="3"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <div class="sm:ml-4 flex-1 min-w-0">
                        <h5 class="mb-1 text-base sm:text-xl font-medium tracking-tight text-neutral-500 truncate">{{uploadedFileName}}</h5>
                    </div>
                    <p (click)="removeTemplateFile()"
                        class="w-full sm:w-auto sm:ml-auto text-westetics-purple-800 border border-westetics-purple-800 hover:bg-westetics-purple-800 hover:text-white cursor-pointer font-medium rounded-md px-4 py-2 sm:py-3 transition-colors text-center text-sm sm:text-base">
                        Reenviar arquivo</p>
                </label>
                <span class="text-red-600 text-sm mb-0 leading-4"
                    *ngIf="
                    (!templateForm.controls['file'].value) && !isEditPage && this.templateForm.invalid && this.templateForm.touched">
                    Por favor, insira um arquivo de template.
                </span>
            </div>
        </form>
        <div class="flex flex-col lg:flex-row gap-4">
            <!-- Variáveis Disponíveis -->
            <div class="w-full lg:w-1/2">
                <h2 class="text-lg sm:text-xl font-bold mb-2">Variáveis Disponíveis</h2>
                <input type="text" class="w-full mb-2 p-2 border rounded text-sm" placeholder="Buscar variáveis disponíveis..."
                       [(ngModel)]="availableFieldsSearch"
                       (ngModelChange)="onAvailableFieldsSearchChange($event)" />
                <select multiple [(ngModel)]="selectedAllFields" class="w-full h-48 sm:h-64 p-2 border rounded text-sm">
                    <option *ngFor="let item of allFieldsFiltered" [value]="item">{{ item.category }} - {{item.name}}</option>
                </select>
            </div>

            <!-- Botões de transferência -->
            <div class="flex lg:flex-col justify-center items-center gap-2 sm:gap-4 py-2 lg:py-0">
                <button (click)="moveToSelected()" class="px-4 py-2 bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded transition-colors text-sm sm:text-base">
                    <span class="hidden lg:inline">→</span>
                    <span class="lg:hidden">↓</span>
                </button>
                <button (click)="moveToAvailable()" class="px-4 py-2 bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded transition-colors text-sm sm:text-base">
                    <span class="hidden lg:inline">←</span>
                    <span class="lg:hidden">↑</span>
                </button>
            </div>

            <!-- Variáveis Selecionadas -->
            <div class="w-full lg:w-1/2">
                <h2 class="text-lg sm:text-xl font-bold mb-2">Variáveis Selecionadas</h2>
                <input type="text" class="w-full mb-2 p-2 border rounded text-sm" placeholder="Buscar variáveis selecionadas..."
                       [(ngModel)]="selectedFieldsSearch"
                       (ngModelChange)="onSelectedFieldsSearchChange($event)" />
                <select multiple [(ngModel)]="selectedSelectedFields" class="w-full h-48 sm:h-64 p-2 border rounded text-sm">
                    <option *ngFor="let item of selectedFieldsFiltered" [value]="item">{{ item.category }} - {{item.name}}
                    </option>
                </select>
            </div>
        </div>
        <span class="text-red-600 text-sm mb-0 leading-4"
            *ngIf="(selectedFields.length === 0) && this.templateForm.invalid && this.templateForm.touched">
            Por favor, selecione pelo menos uma variável.
        </span>
    </div>
</div>